import React, { useRef, useCallback, useState } from 'react';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

/**
 * Canon PV — Eylül 2026 İndirim Kampanyası medya planı.
 *
 * Brief (Merve, 2026-09-09):
 *   "Tasarım 46.200 TL + KDV + 10 Ajans hizmet bedeli + %20 stopaj dahil olmak
 *    üzere toplam bütçemiz 150K. Trafik odaklı gidelim derim. 1 adet Carousel.
 *    Zamanlama: 15-30 Eylül 2026."
 *
 * 🔑🔑 SAYFA DÜZENİ — Efe kararı 2026-09-09: "görüntüsü bizim daha önce yaptığımız
 * kadrajın ötesinde kampanyası gibi planlama olması gerekiyor". Referans
 * `CanonBeyondFrame2026.jsx` (/budget/canon-beyond-the-frame), bölüm bölüm aynı:
 *   Kampanya Detayı (kırmızı kutu) → Bütçe Kırılımı (yatay 5 kart) → Bütçe Dağılımı tablosu (Boyut/Yerleşim/Bütçe/
 *   Gösterim/Erişim/Tıklama/CPC/CPM + TOPLAM) → 4 projeksiyon kartı →
 *   İçerik Takvimi (Gantt + legend) → Zamanlama kutusu → footer.
 * ⚠️ Kixx/Hupalupa Ağustos planlarının düzeni (Total pill, mecra kartları,
 * GENEL TOPLAM satırı) BU MARKA İÇİN KULLANILMAZ — denendi, Efe reddetti.
 *
 * 🔑 CPM / CPC UYDURMA DEĞİL. Canon'un kendi Meta hesabı (act_3256944827800966),
 * canlı Graph API, 1 Haziran – 8 Eylül 2026, TRAFİK hedefli CAROUSEL kampanyaları,
 * publisher_platform + platform_position kırılımı. Taban yalnız FB + IG:
 * 92.566 ₺ harcama, 2.033.505 gösterim, 28.894 link tıklaması.
 * Audience Network tabandan bilerek çıkarıldı; plan da o yerleşimi kapatıyor.
 *
 * ⚠️ HEDEFLEME BÖLÜMÜ 2026-09-10'da KALDIRILDI (Efe: "hedef kitle kısmı yanlış,
 * hedef kitleyi kaldır"). Kayıtlı kitle WorldUnseen Coral v2 bu kampanyaya
 * uymuyordu; sayfa artık kitle iddiasında bulunmuyor. Geri gerekirse git
 * geçmişinde ya da yedekte duruyor.
 */
export default function CanonPVEylul2026() {
  const slideRef = useRef(null);
  const [exporting, setExporting] = useState(false);

  const fmtCur = (n) => '₺' + Math.round(Number(n)).toLocaleString('tr-TR');
  const fmtInt = (n) => Math.round(Number(n)).toLocaleString('tr-TR');

  // ── Bütçe kırılımı ───────────────────────────────────────────────────────
  // Corals yöntemi (Efe kararı): tasarım toplamın İÇİNDEN düşülür, ardından
  // kalan üzerinden %10 ajans hizmet bedeli, ardından %20 stopaj. KDV modellenmez.
  const TOTAL = 150000;
  const DESIGN = 46200;
  const AHK_RATE = 0.10;
  const AHK_FEE = Math.round((TOTAL - DESIGN) * AHK_RATE);  // 10.380
  const MEDIA_BRUT = TOTAL - DESIGN - AHK_FEE;              // 93.420
  const STOPAJ_RATE = 0.20;
  const STOPAJ = Math.round(MEDIA_BRUT * STOPAJ_RATE);      // 18.684
  const NET = MEDIA_BRUT - STOPAJ;                          // 74.736

  // ── Süre ──────────────────────────────────────────────────────────────────
  const DAYS = 16; // 15 Eylül → 30 Eylül dahil
  const dailyNet = NET / DAYS;
  const FREQ = 2.1; // Canon karusel kampanyalarının Haz–Eyl gerçekleşen frekansı

  // ── Yerleşim bazında bütçe ────────────────────────────────────────────────
  // Tek carousel kreatifi, dört yerleşim adset'i. CPM/CPC her satırda o
  // yerleşimin Canon hesabındaki GERÇEKLEŞEN değeri (carousel × trafik).
  const PLACEMENTS = [
    { name: 'Instagram Reels',   size: '1080×1920', placement: 'IG Reels',        tone: 'reels',  cpm: 29.34, cpc: 2.44, sample: 24184, share: 0.35, start: '2026-09-15', end: '2026-09-30', role: 'Hacim motoru' },
    { name: 'Facebook Feed',     size: '1080×1080', placement: 'FB Feed Carousel', tone: 'fbfeed', cpm: 29.88, cpc: 1.73, sample: 8562,  share: 0.25, start: '2026-09-15', end: '2026-09-30', role: 'En ucuz tıklama' },
    { name: 'Instagram Feed',    size: '1080×1080', placement: 'IG Feed Carousel', tone: 'igfeed', cpm: 74.04, cpc: 4.46, sample: 48634, share: 0.28, start: '2026-09-15', end: '2026-09-30', role: 'En yüksek CTR' },
    { name: 'Instagram Stories', size: '1080×1920', placement: 'IG Stories',       tone: 'story',  cpm: 51.73, cpc: 5.03, sample: 7157,  share: 0.12, start: '2026-09-22', end: '2026-09-30', role: 'Aciliyet penceresi' },
  ];

  let alloc = 0;
  const rows = PLACEMENTS.map((p, i) => {
    const isLast = i === PLACEMENTS.length - 1;
    const budget = isLast ? NET - alloc : Math.round(NET * p.share);
    alloc += budget;
    const impressions = Math.round((budget / p.cpm) * 1000);
    const clicks = Math.round(budget / p.cpc);
    const reach = Math.round(impressions / FREQ);
    return { ...p, budget, impressions, clicks, reach };
  });

  const totals = rows.reduce((t, r) => ({
    budget: t.budget + r.budget,
    impressions: t.impressions + r.impressions,
    clicks: t.clicks + r.clicks,
  }), { budget: 0, impressions: 0, clicks: 0 });
  const blendedCpc = totals.budget / totals.clicks;
  const blendedCpm = (totals.budget / totals.impressions) * 1000;
  const estReach = Math.round(totals.impressions / FREQ);
  const ctr = (totals.clicks / totals.impressions) * 100;

  // Ağırlıklandırma yapılmasaydı: hesabın düz karusel ortalaması (₺3,20 CPC).
  const FLAT_CPC = 3.20;
  const flatClicks = Math.round(NET / FLAT_CPC);
  const gain = ((totals.clicks / flatClicks) - 1) * 100;

  // ── Takvim ────────────────────────────────────────────────────────────────
  const TL_START = new Date('2026-09-15');
  const TL_END = new Date('2026-09-30');
  const TL_SPAN = (TL_END - TL_START) / 86400000;
  const tlOff = (d) => (new Date(d) - TL_START) / 86400000;
  const tlPct = (d) => (tlOff(d) / TL_SPAN) * 100;
  const fmtDay = (d) => new Date(d).toLocaleDateString('tr-TR', { day: 'numeric', month: 'short' });
  const durDays = (s, e) => Math.round(tlOff(e) - tlOff(s)) + 1;
  const TONES = { reels: '#CC0000', fbfeed: '#6366f1', igfeed: '#0d9488', story: '#f59e0b' };
  const tlMarks = [
    { label: '15 Eyl · Lansman', date: '2026-09-15' },
    { label: '22 Eyl · Aciliyet', date: '2026-09-22' },
    { label: '30 Eyl · Kapanış', date: '2026-09-30' },
  ];

  // PDF: bölüm bazlı — bir bölüm kalan yere sığmıyorsa ortadan kesilmek yerine
  // yeni sayfaya atılır (BTS planındaki yöntem).
  const exportPdf = useCallback(async () => {
    if (exporting || !slideRef.current) return;
    setExporting(true);
    try {
      const root = slideRef.current;
      const headerEl = root.querySelector('[data-pdf-header]');
      const sectionEls = Array.from(root.querySelectorAll('[data-pdf-section]'));
      const shoot = (el) => html2canvas(el, {
        scale: 2, backgroundColor: '#ffffff', useCORS: true,
        width: el.offsetWidth, height: el.scrollHeight + 12,
        windowWidth: document.documentElement.clientWidth,
      });

      const pdf = new jsPDF('p', 'mm', 'a4');
      const pw = pdf.internal.pageSize.getWidth();
      const ph = pdf.internal.pageSize.getHeight();
      const M = 8;
      const GAP = 6;
      const CW = pw - M * 2;
      const BOTTOM = ph - M - 6;

      const headerCanvas = await shoot(headerEl);
      const headerImg = headerCanvas.toDataURL('image/jpeg', 0.95);
      const headerH = (headerCanvas.height * CW) / headerCanvas.width;
      const TOP_Y = M + headerH + GAP;
      const PAGE_H = BOTTOM - TOP_Y;

      let pages = 0;
      let y = 0;
      const startPage = () => {
        if (pages > 0) pdf.addPage();
        pages += 1;
        pdf.addImage(headerImg, 'JPEG', M, M, CW, headerH);
        y = TOP_Y;
      };
      const slice = (canvas, srcY, srcH) => {
        const c = document.createElement('canvas');
        c.width = canvas.width; c.height = srcH;
        const ctx = c.getContext('2d');
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, c.width, c.height);
        ctx.drawImage(canvas, 0, srcY, canvas.width, srcH, 0, 0, canvas.width, srcH);
        return c.toDataURL('image/jpeg', 0.95);
      };

      startPage();
      for (const el of sectionEls) {
        const canvas = await shoot(el);
        const pxPerMm = canvas.width / CW;
        let srcY = 0;
        let remain = canvas.height / pxPerMm;
        while (remain > 0.5) {
          const avail = BOTTOM - y;
          if (remain <= avail) {
            const srcH = Math.round(remain * pxPerMm);
            pdf.addImage(slice(canvas, srcY, srcH), 'JPEG', M, y, CW, remain);
            y += remain + GAP;
            remain = 0;
            break;
          }
          if (remain <= PAGE_H) { startPage(); continue; }
          const srcH = Math.round(avail * pxPerMm);
          pdf.addImage(slice(canvas, srcY, srcH), 'JPEG', M, y, CW, avail);
          srcY += srcH; remain -= avail;
          startPage();
        }
      }
      for (let i = 1; i <= pages; i += 1) {
        pdf.setPage(i);
        pdf.setFontSize(7);
        pdf.setTextColor(150);
        pdf.text(`Canon PV — Eylül 2026 İndirim Kampanyası · Jellybon x Glowytics · ${i}/${pages}`, pw / 2, ph - M + 2, { align: 'center' });
      }
      pdf.save('Canon_PV_Eylul_2026_Indirim_Kampanyasi.pdf');
    } catch (e) {
      console.error('PDF export failed:', e);
    } finally {
      setExporting(false);
    }
  }, [exporting]);

  const Stat = ({ label, value, sub, tone = 'gray' }) => {
    const tones = {
      gray: 'border-gray-200 bg-gray-50 text-gray-800',
      red: 'border-red-100 bg-red-50 text-red-700',
      indigo: 'border-indigo-100 bg-indigo-50 text-indigo-700',
      green: 'border-emerald-100 bg-emerald-50 text-emerald-700',
    };
    return (
      <div className={`rounded-xl border p-4 ${tones[tone]}`}>
        <span className="text-[10px] font-medium uppercase opacity-70">{label}</span>
        <p className="text-xl font-bold mt-1">{value}</p>
        {sub && <p className="text-[10px] opacity-60 mt-0.5">{sub}</p>}
      </div>
    );
  };

  return (
    <div className="p-4 md:p-6 max-w-5xl mx-auto">
      <div className="flex justify-end mb-3">
        <button
          onClick={exportPdf}
          disabled={exporting}
          className="text-white text-sm font-semibold px-4 py-2 rounded-lg shadow-sm disabled:opacity-60"
          style={{ background: '#CC0000' }}
        >
          {exporting ? 'PDF Oluşturuluyor…' : 'PDF Olarak İndir'}
        </button>
      </div>

      <div ref={slideRef} className="bg-white rounded-2xl shadow-sm border overflow-hidden">
        {/* Header */}
        <div data-pdf-header className="bg-white border-b px-5 py-3 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <img src="/Canon_logo_vector.png" alt="Canon" className="h-12 w-auto object-contain" />
            <div className="h-8 w-px bg-gray-200" />
            <div>
              <p className="text-xs font-bold text-gray-800">PV — Eylül İndirim Kampanyası Medya Planı</p>
              <p className="text-[9px] text-gray-400">Meta Ads (FB + IG) — Trafik · 15 – 30 Eylül 2026</p>
            </div>
          </div>
          <img src="/Jellybon-digital-agency-istanbul.webp" alt="Jellybon" className="h-12 w-auto object-contain" />
        </div>

        <div className="p-6 space-y-6">
          {/* Kampanya detayı */}
          <div data-pdf-section className="rounded-xl border border-red-100 bg-red-50 p-4">
            <p className="text-sm font-bold text-gray-800">Kampanya Detayı</p>
            <p className="text-xs text-gray-600 mt-1 leading-relaxed">
              Canon <strong>PV</strong> tarafının Eylül indirim dönemi kampanyası. 15 – 30 Eylül 2026 tarihleri arasında
              ({DAYS} gün) yayında. Amaç: indirim iletişimini kamera ilgisi olan kitleye ulaştırmak ve
              indirim sayfasına nitelikli trafik çekmek. Yönlendirme reklam hedefi: <strong>Trafik</strong>,
              birincil KPI <strong>link tıklaması</strong>.
              Brief tek kreatif öngörüyor — <strong>1 adet Carousel</strong> — dolayısıyla plandaki asıl karar
              kreatif çeşitliliği değil <strong>yerleşim ağırlığıdır</strong>.
            </p>
          </div>

          {/* Bütçe kırılımı */}
          <div data-pdf-section>
            <p className="text-sm font-bold text-gray-800 mb-2">Bütçe Kırılımı</p>
            <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
              <Stat label="Toplam Bütçe" value={fmtCur(TOTAL)} sub="müşteri toplam" />
              <Stat label="Tasarım" value={'-' + fmtCur(DESIGN)} sub="1 carousel kreatif" tone="indigo" />
              <Stat label="AHK (Ajans %10)" value={'-' + fmtCur(AHK_FEE)} sub={`${fmtCur(TOTAL - DESIGN)} × 0.10`} tone="indigo" />
              <Stat label="Stopaj (%20)" value={'-' + fmtCur(STOPAJ)} sub={`${fmtCur(MEDIA_BRUT)} × 0.20`} tone="indigo" />
              <Stat label="NET Medya" value={fmtCur(NET)} sub="Meta'da harcanan" tone="green" />
            </div>
            <p className="text-[10px] text-gray-400 mt-2">
              Günlük ortalama net harcama ≈ {fmtCur(dailyNet)} ({DAYS} gün). Tasarım + AHK + Stopaj toplam 150K'ya dahildir.
              Brüt medya {fmtCur(MEDIA_BRUT)}. KDV ayrı bir kalem olarak modellenmemiştir.
            </p>
          </div>

          {/* Yerleşim dağılımı */}
          <div data-pdf-section>
            <p className="text-sm font-bold text-gray-800 mb-2">Yerleşim Bazında Bütçe Dağılımı (1 Kreatif · 4 Yerleşim)</p>
            <div className="overflow-x-auto rounded-xl border border-gray-200">
              <table className="w-full text-xs">
                <thead>
                  <tr className="bg-gray-50 text-gray-500 uppercase text-[10px]">
                    <th className="text-left px-3 py-2 font-semibold">Yerleşim</th>
                    <th className="text-left px-3 py-2 font-semibold">Boyut</th>
                    <th className="text-left px-3 py-2 font-semibold">Rol</th>
                    <th className="text-right px-3 py-2 font-semibold">Bütçe (NET)</th>
                    <th className="text-right px-3 py-2 font-semibold">Gösterim</th>
                    <th className="text-right px-3 py-2 font-semibold">Erişim*</th>
                    <th className="text-right px-3 py-2 font-semibold">Tıklama</th>
                    <th className="text-right px-3 py-2 font-semibold">CPC</th>
                    <th className="text-right px-3 py-2 font-semibold">CPM</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {rows.map((r) => (
                    <tr key={r.name} className="hover:bg-gray-50">
                      <td className="px-3 py-2 font-semibold text-gray-800">
                        {r.name}
                        <span className="block text-[9px] font-normal text-gray-400">{r.placement}</span>
                      </td>
                      <td className="px-3 py-2 text-gray-500">{r.size}</td>
                      <td className="px-3 py-2">
                        <span className="text-[9px] font-semibold px-2 py-0.5 rounded-full border"
                          style={{ color: TONES[r.tone], borderColor: TONES[r.tone] + '40', background: TONES[r.tone] + '12' }}>
                          {r.role}
                        </span>
                      </td>
                      <td className="px-3 py-2 text-right tabular-nums">
                        {fmtCur(r.budget)}
                        <span className="block text-[9px] font-normal text-gray-400">%{Math.round((r.budget / NET) * 100)}</span>
                      </td>
                      <td className="px-3 py-2 text-right tabular-nums">{fmtInt(r.impressions)}</td>
                      <td className="px-3 py-2 text-right tabular-nums">{fmtInt(r.reach)}</td>
                      <td className="px-3 py-2 text-right tabular-nums">{fmtInt(r.clicks)}</td>
                      <td className="px-3 py-2 text-right tabular-nums">₺{r.cpc.toFixed(2)}</td>
                      <td className="px-3 py-2 text-right tabular-nums">₺{r.cpm.toFixed(2)}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr className="bg-red-50 font-bold text-gray-800">
                    <td className="px-3 py-2" colSpan={3}>TOPLAM</td>
                    <td className="px-3 py-2 text-right tabular-nums">{fmtCur(totals.budget)}</td>
                    <td className="px-3 py-2 text-right tabular-nums">{fmtInt(totals.impressions)}</td>
                    <td className="px-3 py-2 text-right tabular-nums">{fmtInt(estReach)}</td>
                    <td className="px-3 py-2 text-right tabular-nums">{fmtInt(totals.clicks)}</td>
                    <td className="px-3 py-2 text-right tabular-nums">₺{blendedCpc.toFixed(2)}</td>
                    <td className="px-3 py-2 text-right tabular-nums">₺{blendedCpm.toFixed(2)}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
            <p className="text-[10px] text-gray-400 mt-2 leading-relaxed">
              *Erişim, ~{FREQ} ortalama frekans varsayımıyla tahminidir. Tahmini CTR ≈ %{ctr.toFixed(2)}.
              CPC ve CPM değerleri her satırda o yerleşimin Canon Meta hesabındaki <strong>gerçekleşen</strong> değeridir
              (1 Haziran – 8 Eylül 2026, trafik hedefli carousel kampanyaları, toplam {fmtCur(92566)} harcama ·
              {' '}{fmtInt(2033505)} gösterim · {fmtInt(28894)} link tıklaması). Audience Network tabandan bilerek çıkarıldı;
              plan da o yerleşimi kapatıyor. Bütçe hesabın düz karusel ortalamasına (₺{FLAT_CPC.toFixed(2)} CPC) eşit
              dağıtılsaydı {fmtInt(flatClicks)} tıklama beklenirdi; yerleşim ağırlıklandırması bunu
              {' '}<strong>%{gain.toFixed(0)} artırıyor</strong>. Sayılar Meta açık artırma dinamiklerine göre değişebilir.
            </p>
          </div>

          {/* Projeksiyon özeti */}
          <div data-pdf-section className="grid grid-cols-2 md:grid-cols-4 gap-3">
            <Stat label="Toplam Tıklama" value={fmtInt(totals.clicks)} sub="link tıklaması (tahmini)" tone="green" />
            <Stat label="Ort. CPC" value={'₺' + blendedCpc.toFixed(2)} sub={`CTR %${ctr.toFixed(2)}`} />
            <Stat label="Toplam Gösterim" value={fmtInt(totals.impressions)} sub={`CPM ₺${blendedCpm.toFixed(2)}`} />
            <Stat label="Tahmini Erişim" value={fmtInt(estReach)} sub={`~${FREQ} frekans`} />
          </div>

          {/* İçerik takvimi */}
          <div data-pdf-section>
            <p className="text-sm font-bold text-gray-800 mb-1">Yayın Takvimi (4 Yerleşim)</p>
            <p className="text-[10px] text-gray-400 mb-3">
              Her yerleşimin bütçe payı (NET üzerinden), yayına giriş tarihi ve yayında kalacağı süre.
              Üç yerleşim 15 Eylül'de birlikte açılır ve kampanya boyunca yayında kalır; tıklaması en pahalı olan
              Instagram Stories 22 Eylül'de, kapanışa dokuz gün kala aciliyet mesajıyla devreye girer. Tümü 30 Eylül'de kapanır.
            </p>
            <div className="rounded-xl border border-gray-200 p-4 overflow-hidden">
              {/* Tarih başlıkları */}
              <div className="flex">
                <div className="w-40 md:w-52 shrink-0" />
                <div className="relative flex-1 h-4">
                  {tlMarks.map((m, i) => (
                    <span
                      key={m.label}
                      className="absolute top-0 text-[9px] font-semibold text-gray-400 whitespace-nowrap"
                      style={{
                        left: `${tlPct(m.date)}%`,
                        transform: i === 0 ? 'none' : i === tlMarks.length - 1 ? 'translateX(-100%)' : 'translateX(-50%)',
                      }}
                    >
                      {m.label}
                    </span>
                  ))}
                </div>
              </div>

              <div className="relative mt-1.5">
                {/* dikey çizgiler */}
                <div className="absolute inset-0 flex pointer-events-none">
                  <div className="w-40 md:w-52 shrink-0" />
                  <div className="relative flex-1">
                    {tlMarks.map((m) => (
                      <div key={m.label} className="absolute top-0 bottom-0 w-px bg-gray-100" style={{ left: `${tlPct(m.date)}%` }} />
                    ))}
                  </div>
                </div>

                {rows.map((r) => {
                  const left = tlPct(r.start);
                  const width = Math.max(tlPct(r.end) - left, 1.5);
                  const nearEnd = left > 60;
                  return (
                    <div key={r.name} className="flex items-center h-12 relative">
                      <div className="w-40 md:w-52 shrink-0 pr-3">
                        <p className="text-[11px] font-semibold text-gray-800 whitespace-nowrap" style={{ lineHeight: '1.5' }}>{r.name}</p>
                        <div className="flex items-center justify-between gap-1">
                          <span className="text-[9px] text-gray-400">Carousel</span>
                          <span className="text-[9px] font-bold tabular-nums" style={{ color: TONES[r.tone] }}>
                            {fmtCur(r.budget)} · %{Math.round((r.budget / NET) * 100)}
                          </span>
                        </div>
                      </div>
                      <div className="relative flex-1 h-12">
                        <div className="absolute top-1/2 -translate-y-1/2" style={{ left: `${left}%`, width: `${width}%` }}>
                          <div className={`absolute bottom-full mb-1 whitespace-nowrap text-[8.5px] font-medium text-gray-500 ${nearEnd ? 'right-0' : 'left-0'}`}>
                            {fmtDay(r.start)} → {fmtDay(r.end)} · {durDays(r.start, r.end)}g
                          </div>
                          <div className="h-4 rounded-full shadow-sm" style={{ background: TONES[r.tone] }} />
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

              {/* Legend */}
              <div className="flex flex-wrap items-center justify-between gap-3 mt-4 pt-3 border-t border-gray-100">
                <div className="flex flex-wrap items-center gap-3">
                  {rows.map((r) => (
                    <span key={r.name} className="flex items-center gap-1.5 text-[9px] text-gray-500">
                      <span className="w-3 h-3 rounded-full" style={{ background: TONES[r.tone] }} />{r.name}
                    </span>
                  ))}
                </div>
                <span className="text-[9px] text-gray-400">
                  Toplam paid: <strong className="text-gray-600">{fmtCur(NET)}</strong> · {DAYS} gün · tek carousel kreatifi
                </span>
              </div>
            </div>
          </div>

          {/* Zamanlama */}
          <div data-pdf-section className="rounded-xl border border-gray-200 bg-gray-50 p-4">
            <p className="text-sm font-bold text-gray-800">Zamanlama</p>
            <p className="text-xs text-gray-700 mt-1 leading-relaxed">
              Yayın: <strong>15 – 30 Eylül 2026</strong> ({DAYS} gün), indirim dönemi boyunca kesintisiz.
              İlk hafta indirimin kendisini duyurur, 22 Eylül'den itibaren Stories ile "son günler" aciliyet vurgusu eklenir.
              Bütçe gün bazında dengeli dağıtılır; performansa göre yerleşim ağırlıkları kampanya içinde optimize edilir.
            </p>
            <p className="text-[10px] text-gray-500 mt-2 leading-relaxed">
              <strong>Ölçümleme ön koşulu:</strong> Canon hesabında link tıklamasının açılış sayfası görüntülemesine dönüşme
              oranı formattan formata %0,4 ile %69 arasında değişiyor. Bu bir performans farkı değil, Meta pikselinin bazı
              açılış sayfalarında tetiklenmediğinin işareti. İndirim sayfası yayına girmeden önce pikselin o sayfada
              çalıştığı doğrulanmalı.
              <br />
              <strong>Kreatif notu:</strong> Tek carousel ile {fmtInt(totals.impressions)} gösterim basıldığında kişi başı
              ~{FREQ} tekrara çıkılıyor ve ikinci haftada CTR düşmeye başlar. Tasarım bütçesinde ek maliyet doğurmayan iki
              önlem var: kart sırasının değiştirildiği ikinci bir varyant ve iki ayrı metin.
              <br />
              <strong>Alternatif akış:</strong> CCMS akışındaki 5 günlük parçalı yapı tercih edilirse aynı bütçe 3 × 5 günlük
              uçuşa bölünür; öğrenme evresi üç kez baştan başladığı için tıklama maliyeti yükselir. Kesintisiz akış öneriliyor.
            </p>
          </div>

          {/* Footer */}
          <div className="flex justify-between items-center pt-3 border-t border-gray-100">
            <img src="/Canon_logo_vector.png" alt="Canon" className="h-7 w-auto object-contain" />
            <p className="text-[9px] text-gray-400">
              {new Date().toLocaleDateString('tr-TR')} · Confidential · Jellybon × Glowytics
            </p>
            <img src="/Jellybon-digital-agency-istanbul.webp" alt="Jellybon" className="h-6 w-auto object-contain" />
          </div>
        </div>
      </div>
    </div>
  );
}
